<div class="white-box border-radius p-4 mt-4 mx-4">
	<div class="metrics-row" [ngClass]="showDeviceCount ? 'three-items' : 'two-items'">

		<div class="metric-card" *ngIf="showDeviceCount">
			<div class="metric-icon">
				<fa-icon icon="clipboard-list" size="3x"></fa-icon>
			</div>
			<div class="metric-value">{{ studyDevicesCount }}</div>
			<div class="metric-label">{{ 'studies.iotah_ps_devices_count' | translate }}</div>
		</div>

		<div class="metric-card">
			<div class="metric-icon">
				<fa-icon icon="clipboard-check" size="3x"></fa-icon>
			</div>
			<div class="metric-value">{{ completedStudiesCount }}</div>
			<div class="metric-label">{{ 'studies.completed_studies_count' | translate }}</div>
		</div>

		<div class="metric-card">
			<div class="metric-icon">
				<fa-icon icon="clipboard" size="3x"></fa-icon>
			</div>
			<div class="metric-value">{{ activeStudiesCount }}</div>
			<div class="metric-label">{{ 'studies.active_studies_count' | translate }}</div>
		</div>

	</div>
</div>

<app-studies-inventory *ngIf="showDeviceCount"></app-studies-inventory>
<app-studies-section mode="active"></app-studies-section>
<app-studies-section mode="completed"></app-studies-section>